import { fade, makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  container: {
    maxWidth: 1000,
    margin: '0 auto',
  },
  headerRow: {
    borderBottom: `1px solid ${theme.colors.darkGrey}`,
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: 13,
    minHeight: 30,
    boxSizing: 'border-box',
    padding: theme.spacing(1),
    cursor: 'pointer',

    '&:hover': {
      opacity: 0.7,
    },
  },
  rowBg: {
    backgroundColor: theme.palette.action.disabledBackground,
  },
  newRow: {
    backgroundColor: (props) => (props.showbg ? fade(theme.colors.red, 0.4) : fade(theme.colors.red, 0.2)),
  },
  info: {
    width: '85%',
    display: 'flex',
    paddingRight: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  time: {
    width: '15%',
  },
  type: {
    width: '20%',
    marginTop: theme.spacing(0.5),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  location: {
    width: '25%',
    marginTop: theme.spacing(0.5),
    marginRight: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginRight: 0,
    },
  },
  description: {
    flexGrow: 1,
    marginTop: theme.spacing(0.5),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  headerHide: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },

  locationContainer: {
    backgroundColor: (props) => (props.locationOn ? theme.colors.lightGreen : theme.palette.action.disabled),
    borderRadius: 10,
    maxWidth: 500,
    margin: '10px auto',
    padding: `5px 10px`,
    position: 'relative',

    '& .MuiIcon-root': {
      position: 'absolute',
      top: 10,
      left: 8,
      color: theme.colors.black,
    },
  },
  locationContent: {
    marginLeft: theme.spacing(3),

    '& p': {
      fontSize: 12,
      color: theme.colors.black,
    },
    '& .MuiFormControlLabel-label': {
      fontWeight: 'bold',
      color: theme.colors.darkGrey,
      fontSize: 14,
    },
  },
}));
